export default function PHP_ob_list_handlers() {
  return (
    <div>
      <h1>PHP_ob_list_handlers</h1>
    </div>
  );
}
